(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/views/autogiro-approval.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/views/autogiro-approval.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.views.AutogiroApproval = Marionette.View.extend({
    ui: {
      approveCheckbox: '#js-approve-checkbox',
      approveBtn: '.js-approve-ag',
      registerBankaccountBtn: '.js-register-bankaccount',
      changeBankaccountBtn: '.js-change-bankaccount'
    },
    events: {
      'change @ui.approveCheckbox': 'toggleTermsApproved',
      'click @ui.approveBtn': 'approveBtnClicked',
      'click @ui.registerBankaccountBtn': 'registerBankaccountBtnClicked',
      'click @ui.changeBankaccountBtn': 'changeBankaccountBtnClicked'
    },
    template(data) {
      return svs.tur.start_subscription.templates.autogiro_approval(data);
    },
    toggleTermsApproved() {
      this.getUI('approveBtn').attr('disabled', !this.getUI('approveCheckbox')[0].checked);
    },
    approveBtnClicked(e) {
      svs.tur.start_subscription.utils.preventDoubleClick(e.target);
      this.options.context.createDirectDebitPermission();
    },
    registerBankaccountBtnClicked() {
      svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsWithdrawalRegisterBankAccount'), {
        returnUrl: window.location
      });
      return false;
    },
    changeBankaccountBtnClicked() {
      svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsWithdrawalChangeBankAccount'), {
        returnUrl: window.location
      });
      return false;
    }
  });
})(Backbone, _, svs);

 })(window);